import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { API, useAuth } from "@/App";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      
      // Parse token and redirect from hash
      const tokenMatch = hash.match(/token=([^&]+)/);
      const redirectMatch = hash.match(/redirect=([^&]+)/);
      
      if (!tokenMatch) {
        navigate("/login");
        return;
      }

      const token = tokenMatch[1];
      const redirectUrl = redirectMatch ? decodeURIComponent(redirectMatch[1]) : "/dashboard";

      try {
        // Verify token and get user data from the API
        const response = await fetch(`${API}/auth/google/verify`, {
          method: "POST",
          headers: { 
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          credentials: "include"
        });

        if (response.ok) {
          const data = await response.json();
          if (data.authenticated && data.user) {
            login(data.user, data.token);
            // Clear hash and navigate to the redirect URL
            window.history.replaceState(null, "", window.location.pathname);
            
            // Parse redirect URL to get just the pathname
            try {
              const url = new URL(redirectUrl);
              navigate(url.pathname, { state: { user: data.user } });
            } catch {
              navigate("/dashboard", { state: { user: data.user } });
            }
          } else {
            navigate("/login");
          }
        } else {
          navigate("/login");
        }
      } catch (error) {
        console.error("Auth callback error:", error);
        navigate("/login");
      }
    };

    processAuth();
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-slate-600">Signing you in...</p>
      </div>
    </div>
  );
}
